import type { Destructor } from "@suse-o11y/destructor";
import { onTimeout } from "@suse-o11y/on-timeout";

/**
 * Executes a callback function when the browser is idle.
 * If the browser supports `requestIdleCallback`, it will use that to schedule the callback.
 * Otherwise, it will fallback to using `setTimeout`.
 *
 * @param callback - The callback function to be executed when the browser is idle.
 * @returns A cleanup function that can be used to cancel the idle callback.
 */
export function onIdle(callback: VoidFunction): Destructor {
	// Safari does not support it https://caniuse.com/requestidlecallback
	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	if ("requestIdleCallback" in window) {
		// biome-ignore lint/style/noRestrictedGlobals: encapsulation
		const idleId = window.requestIdleCallback(callback);

		// biome-ignore lint/style/noRestrictedGlobals: encapsulation
		return () => window.cancelIdleCallback(idleId);
	}

	return onTimeout(callback, 0);
}
